import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectAllTransactions } from "store/payments/selectors";
import { selectUserCredits } from "store/users/selectors";

import TableHeader from "./components/TableHeader";
import TableBody from "./components/TableBody";

import classes from "./styles.module.scss";

const Table = ({ transactions, userCredits, filters, setFilters, fetchMoreTransactions, lazyLoadData, loading }) => {
    const { total: userTotalLegacy = 0, credits: userTotalCredits = 0 } = userCredits || {};
    
    return (
        <div className={classes.transactionsTableContainer}>
            <TableHeader filters={filters} setFilters={setFilters} userTotalCredits={userTotalCredits} />
            <TableBody
                transactions={transactions}
                fetchMoreTransactions={fetchMoreTransactions}
                lazyLoadData={lazyLoadData}
                loading={loading}
            />
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    transactions: selectAllTransactions,
    userCredits: selectUserCredits,
});

export default connect(mapStateToProps, null)(Table);
